import { render, staticRenderFns } from "./WirelessInfraredGateway.vue?vue&type=template&id=5e769508&scoped=true&"
import script from "./WirelessInfraredGateway.vue?vue&type=script&lang=js&"
export * from "./WirelessInfraredGateway.vue?vue&type=script&lang=js&"
import style0 from "./WirelessInfraredGateway.vue?vue&type=style&index=0&id=5e769508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e769508",
  null
  
)

export default component.exports